import type { PortsSource } from '@felix/ui';
import { officeApi } from './api.js';

/**
 * Ofiste limanlar ve mesafe tablosu (ADR 0048 §3–§4): tabloyu ve şirket limanlarını ofis yazar;
 * seferin güzergâhı gemide planlanır, ofiste salt okunur.
 */
export const officePortsSource: PortsSource = {
  scope: 'web',
  companyPorts: () => officeApi.companyPorts(),
  distances: () => officeApi.portDistances(),
  route: (voyageId) => officeApi.voyageRoute(voyageId),
  editor: {
    createDistance: (input) => officeApi.createPortDistance(input),
    updateDistance: (id, patch) => officeApi.updatePortDistance(id, patch),
    removeDistance: async (id, rowVersion) => {
      await officeApi.removePortDistance(id, rowVersion);
    },
    history: (id) => officeApi.portDistanceHistory(id),
    importCsv: (text, dryRun) => officeApi.importPortDistances(text, dryRun),
    createPort: (input) => officeApi.createCompanyPort(input),
    updatePort: (id, rowVersion, input) => officeApi.updateCompanyPort(id, rowVersion, input),
    removePort: async (id, rowVersion) => {
      await officeApi.removeCompanyPort(id, rowVersion);
    },
  },
};
